// Countries for which we currently collect a healthcare professional registration ID.
// Keyed by ISO country code (see COUNTRIES query) to avoid relying on country name strings.
export const PROFESSIONAL_REGISTRATION_TOOLTIP =
  "Why we ask: Confirms you're a licensed healthcare professional, matches you to relevant projects, and supports regulatory reporting (e.g. US Sunshine Act) when required."

// Expected digit count per registration type, used to build a friendly validation message.
export const PROFESSIONAL_REGISTRATION_TYPE_DIGITS = {
  NPI: 10,
  RPPS: 11,
  ADELI: 9,
  INAMI: 11,
  BIG: 11,
}

export const PROFESSIONAL_REGISTRATION = {
  us: {
    types: ['NPI'],
    label: 'NPI — National Provider Identifier',
    placeholder: '10-digit NPI',
    helper:
      "If you're a US-based healthcare professional, enter your 10-digit National Provider Identifier (NPI).",
  },
  fr: {
    types: ['RPPS', 'ADELI'],
    label: 'French HCP registration (RPPS or ADELI)',
    placeholder: 'Enter your RPPS or ADELI number',
    helper:
      "If you're a France-based healthcare professional, enter your RPPS (11 digits) or ADELI (9 digits) registration number.",
  },
  be: {
    types: ['INAMI'],
    label: 'INAMI/RIZIV number',
    placeholder: '11-digit INAMI/RIZIV number',
    helper:
      "If you're a Belgium-based healthcare professional, enter your 11-digit INAMI/RIZIV number.",
  },
  nl: {
    types: ['BIG'],
    label: 'BIG number',
    placeholder: '11-digit BIG number',
    helper:
      "If you're a Netherlands-based healthcare professional, enter your 11-digit BIG number (the Dutch HCP registry ID).",
  },
}
